import { Domain } from '../domains/domain';

export class Product {
  public id?: string;
  public name: string;
  public domain?: Domain;
}
